// @flow

import styled, { css } from 'styled-components';
import media from '../../../../../../helpers/media';
import { SEMIBOLD } from '../../../../../../helpers/fontWeight';
import type { Theme } from '../../../../../../types';

type Props = {
  id: string,
  isActive: boolean,
};

export default styled<any, Theme, Props>('a')`
  display: inline-block;
  text-decoration: none;
  font-size: ${props => props.theme.progressRow.stepsFontSize};
  color: ${props => props.theme.progressRow.steps.main};
  font-weight: ${SEMIBOLD};

  &.active {
    color: ${props => props.theme.progressRow.steps.active};
  }

  &:hover {
    color: ${props => props.theme.progressRow.steps.hover};
  }

  ${media.md(css`
    padding: 2rem 0.5rem;
    border-bottom: 4px solid transparent;

    &.active {
      border-color: ${props => props.theme.progressRow.steps.active};
    }

    &:hover {
      border-color: ${props => props.theme.progressRow.steps.hover};
    }
  `)}

  ${media.lg(css`
    margin: 0 1rem;
    padding: 2.05rem 1rem;
  `)}
`;
